module.exports = __webpack_public_path__ + "static/media/jamaica.182e12f7.jpg";